import { PopOver, styled, Flex } from '@fareye/ui'
import { toTileCase } from '@fareye/utils'
import React from 'react'
import { ActiveText, DownIconStyle } from '../../../style/styled'
import { Span, BoldText } from '../../../components/Timeline/styled'

interface ICarrierPopover {
  vehicleData: any[]
  currentVehicle: string
}

export const IconContainer: any = styled(Flex)`
  padding: 1px;
  cursor: pointer;
`

export default function VehiclePopover({
  vehicleData,
  currentVehicle
}: ICarrierPopover) {
  return (
    <PopOver style={{ margin: '0 10px' }} variant="arrow Bottom-Center">
      <IconContainer>
        <Span>{currentVehicle}</Span>
        <DownIconStyle style={{ marginLeft: '5px' }} size={8} />
      </IconContainer>
      <PopOver.Body>
        <Flex
          style={{ padding: '5px 10px', maxHeight: '100px', overflow: 'auto' }}
          column
        >
          {vehicleData.map((ele, index) => {
            const { vehicleNo, id, sequence } = ele
            return (
              <Flex key={id + index} style={{ padding: '5px 8px' }} column>
                <BoldText style={{ textTransform: 'uppercase' }}>
                  {vehicleNo}
                </BoldText>
              </Flex>
            )
          })}
        </Flex>
      </PopOver.Body>
    </PopOver>
  )
}
